import { AppDomainConfig } from "../../envConfig";

import colors from "./colors";
import iconCategories from "./icons.json";

const config: Partial<AppDomainConfig> = {
  domains: ["ch"],
  font: '16px "FrutigerLTStd-Light", sans-serif',
  iconCategories,
  id: "OEBB",
  name: "ÖBB",
  settings: {
    stops_api_bbox: "8.92090,45.95115,17.81982,49.29647",
    stops_api_prefagencies: "sbb",
  },
  slug: "oebb",
  title: "ÖBB",
  ...colors,
};
export default config;
